module.exports = __webpack_public_path__ + "img/dynamic.1794971.png";